<template>
  <div :id="tooltipId">
    <v-card v-if="showTooltips"
      class="pa-3 mb-6 primary darken-2 overlay-reservoir-center" :max-height="max_height" :allow-overflow="true"
      style="overflow-x: hidden; overflow-y: auto" @mouseleave="hoverOut">
      <v-card-title v-if="title">
        <v-row :align="title.label_subtitle ? 'start' : 'center'">
          <v-icon v-if="title.icon_params" class="pa-1 mr-2" size="16" color="white"
            :style="`border-radius: 50%;background-color: ${title.icon_params.background_color}`">{{
              title.icon_params.class }}</v-icon>
          <div>
            <h1 v-if="title.value_title" class="pa-0 ma-0 white--text tooltip-title">
              <span v-if="title.label_title">{{ title.label_title }}&nbsp;&nbsp;-&nbsp;&nbsp;</span>{{ title.value_title
              }}
            </h1>
            <h1 v-else class="pa-0 ma-0 white--text tooltip-title">
              {{ title.name }}
            </h1>
            <h2 v-if="title.value_subtitle" class="mt-0 pa-0 ma-0 tooltip-subtitle">
              <span v-if="title.label_subtitle">{{ title.label_subtitle }}:&nbsp;&nbsp;</span>
              <span>{{ title.value_subtitle }}</span>
            </h2>
          </div>
        </v-row>
      </v-card-title>

      <div v-for="(showTooltip, index) in showTooltips" :key="index">
        <v-card-text v-if="showTooltip.items.length" class="px-2 mt-n5" style="padding-bottom: 8px;">
          <div class="mt-3" v-for="(property, index2) in showTooltip.items" :key="index2">
            <v-icon class="mr-4" size="16" color="secondary lighten-1">{{
              property.icon_label ? property.icon_label : 'circle'
            }}</v-icon>
            <span class="white--text mr-1" style="font-weight: normal; font-size: 14px; line-height: 18px">{{
              property.label }}:&ensp;</span>
            <strong v-if="property.value" class="white--text"
              style="font-weight: bold; font-size: 14px; line-height: 18px">{{ fixValue(property.value) }} {{
                property.suffix }}</strong>
            <strong v-else class="white--text" style="font-weight: bold; font-size: 14px; line-height: 18px">Em
              breve</strong>
          </div>
        </v-card-text>

        <v-card-text v-if="showTooltip.updatedAt">
          <v-row class="align-center justify-start">
            <v-icon class="ml-1 mr-3" color="white" size="14" left>restore</v-icon>
            <span class="white--text" style="
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 10px;
                line-height: 14px;
              ">
              Atualizado em {{ formatDate(showTooltip.updatedAt) }}
            </span>
            <!-- <span v-else class="white--text">Atualizado em ##/##/####</span> -->
          </v-row>
        </v-card-text>

        <v-card-text v-if="showTooltips && showTooltips.length > 1" class="mt-n5">
          <v-row class="align-center justify-center">
            <v-col cols="12">
              <hr style="display: block; border: 1px solid white" />
            </v-col>
          </v-row>
        </v-card-text>
      </div>
    </v-card>

<!--     <div v-if="showTooltip && tooltipParams[0].name == 'Desmatamentos'">
      <TooltipDesmatamento :tooltipParams="tooltipParams" :showTooltip="showTooltip"></TooltipDesmatamento>
    </div> -->
  </div>
</template>

<script>
 import moment from 'moment';
/*
 */
export default {
  name: 'TooltipCardMapConservation',
  props: {
    tooltipParams: {
      type: Array,
    },
    tooltipId: {
      type: String,
      default: 'tooltip-card',
    },
    overlayLayerTooltipCard: {
      type: Object,
    },
  },

/*
  components: { TooltipDesmatamento }, */
  data: () => ({
    title: {},
    max_height: 'auto',
    copy: undefined,
    /*Status Popover in Table*/
    declineReason: false,
  }),

  computed: {
    showTooltips() {
      let tooltips = [];
      const focosCalorLayer = 688;
      if (this.tooltipParams.length) {
        for (const tooltipKey in this.tooltipParams) {
          if (tooltips.length) {
            const { idLayer, zindex } = tooltips[0];
            if (this.tooltipParams[tooltipKey].zindex > zindex) {
              tooltips = [this.tooltipParams[tooltipKey]];
            } else if (
              this.tooltipParams[tooltipKey].idLayer == idLayer &&
              idLayer == focosCalorLayer
            ) {
              tooltips.push(this.tooltipParams[tooltipKey]);
            } else if (this.tooltipParams[tooltipKey].name === 'Agrotóxico') {
              tooltips.push(this.tooltipParams[tooltipKey]);
            } else if (this.tooltipParams[tooltipKey].name === 'Cargas Difusas') {
              tooltips.push(this.tooltipParams[tooltipKey]);
            }
          } else {
            tooltips.push(this.tooltipParams[tooltipKey]);
          }
        }
      }
      let self = this;
      if (tooltips) {
        self.title = tooltips[0];
        if (tooltips.length >= 1) {
          self.copy = tooltips;
        }
      }
      if (tooltips.length === 0 && self.copy) {
        self.title = self.copy[0];
        tooltips = self.copy;
      }
      self.max_height = tooltips.length > 1 ? '200' : 'auto';
      return tooltips;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    fixValue(value) {
      if (typeof (value) === 'number') {
        if (this.tooltipParams[0]?.name === 'Cargas Difusas') {
          return (
            value.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) + ' kg/dia'
          );
        }
        if (this.tooltipParams[0]?.name === 'Agrotóxico') {
          return (
            (value * 1000).toLocaleString('pt-BR', {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
            }) + ' kg/ano'
          );
        }
      }
      return value;
    },
    hoverOut: function () {
      setTimeout(() => {
        this.overlayLayerTooltipCard.setPosition(undefined);
      }, 2000);
    },
  },
};
</script>

<style scoped>
.tooltip {
  width: 300px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 6px;
  opacity: 0.8;
  position: absolute;
  transition: 0.5s all ease;
  transition-delay: 0.5s;
  z-index: 1000;
}

hr.solid {
  border-top: 2px solid #fff;
}

.tooltip-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
}

.tooltip-subtitle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
}
</style>
